export enum EDITABLE_SUBSCRIPTION_PRODUCT_FIELDS {
  QUANTITY = 'quantity',
  SIZE = 'size',
}
